import { render, staticRenderFns } from "./ListOfUsers.vue?vue&type=template&id=387f8180&scoped=true"
import script from "./ListOfUsers.vue?vue&type=script&lang=js"
export * from "./ListOfUsers.vue?vue&type=script&lang=js"
import style0 from "./ListOfUsers.vue?vue&type=style&index=0&id=387f8180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f8180",
  null
  
)

export default component.exports